<template>
  <div class="sf-page">
    <top-header v-bind:title="$t('customEmailTemplates')">
    </top-header>
    <email-test-mode-banner />
    <v-progress-linear color="accent"
                       indeterminate
                       v-bind:active="loading" />
    <v-snackbar right
                top
                v-model="snackbar">
      {{ snackbarText }}
    </v-snackbar>
    <div class="sf-container">
      <custom-email-template-list v-bind:customEmailTemplates="customEmailTemplates"
                                  v-on:convert="convert"
                                  v-on:duplicate="duplicate" />
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'

  import CustomEmailTemplateList from '@/components/administration/CustomEmailTemplateList'
  import EmailTestModeBanner from '@/components/administration/EmailTestModeBanner'
  import TopHeader from '@/components/common/TopHeader'

  export default {
    components: {
      CustomEmailTemplateList,
      EmailTestModeBanner,
      TopHeader
    },
    computed: {
      ...mapGetters([ 'customEmailTemplates' ])
    },
    async created() {
      this.loading = true
      await Promise.all([
        this.$store.dispatch('loadCustomEmailTemplates'),
        this.$store.dispatch('loadEmailDesignerData')
      ])
      this.loading = false
    },
    data: () => ({
      loading: false,
      snackbar: false,
      snackbarText: ''
    }),
    methods: {
      ...mapActions([
        'deleteCustomEmailTemplate'
      ]),
      async convert({ id }) {
        try {
          await this.$store.dispatch('convertCustomEmailTemplate', { id })
          this.snackbarText = this.$t('converted')
        } catch (e) {
          this.snackbarText = e.errors && e.errors.length ? e.errors.join(' ') : e.message
        }

        this.snackbar = true
      },
      async duplicate({ id, name, kind }) {
        try {
          await this.$store.dispatch('duplicateCustomEmailTemplate', { id, name, kind })
          this.snackbarText = kind === 'Layout' ? this.$t('savedAsLayout') : this.$t('duplicated')
        } catch (e) {
          this.snackbarText = e.message
        }

        this.snackbar = true
      }
    },
    name: 'CustomEmailTemplates'
  }
</script>

<i18n>
  {
    "de": {
      "customEmailTemplates": "E-Mail-Vorlagen",
      "converted": "Vorlage umgewandelt. Sie kann jetzt frei gestaltet werden.",
      "duplicated": "Vorlage dupliziert.",
      "savedAsLayout": "Als Layout gespeichert."
    },
    "en": {
      "customEmailTemplates": "Custom email templates",
      "converted": "Template converted. It can now be designed freely.",
      "duplicated": "Template duplicated.",
      "savedAsLayout": "Saved as layout."
    }
  }
</i18n>
